export default "__VITE_ASSET__XBNh7qN3__"